import {
  Col,
  Card,
  Table,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useSiteContext } from "./Providers/SSCProvider";
import Icon from "../generic/Icon";
import { useEffect } from "react";

const CarrierContactCard = () => {
  const {
    selectedCarrierInfo,
    setSelectedCarrierInfo,
    setCarrierContacts,
    isLoading,
    sortedCarrierContacts,
  } = useSiteContext();

  useEffect(() => {
    console.log("selectedCarrierInfo changed:", selectedCarrierInfo);
  }, [selectedCarrierInfo]);

  return (
    <Col className="ps-0" sm={5}>
      <Card className="shadow-sm p-1" style={{ height: "100%" }}>
        <Card.Body className="py-0" style={{ padding: "0" }}>
          <div
            className="carrier-info-panel"
            style={{
              height: "180px",
              overflow: "auto",
            }}
          >
            <Table hover responsive className="carrier-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Role</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th style={{ float: "right" }}>
                    <Icon
                      onClick={() => {
                        setSelectedCarrierInfo(null);
                        setCarrierContacts([]);
                      }}
                      name={"close"}
                      overrides={{
                        disabled: isLoading,
                        tooltip: "Close Carrier Table",
                        tooltipPlacement: "bottom",
                      }}
                      id="export-icon"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedCarrierContacts?.map((contact) => (
                  <tr key={contact.id}>
                    <td>{contact.name || ""}</td>
                    <td>{contact.type || ""}</td>
                    <td>{contact.role || ""}</td>
                    <td>{contact.mainPhone || ""}</td>
                    <td>{contact.email || ""}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="tooltip-view-site-details">
              Open Carrier Detials
            </Tooltip>
          }
        >
          <span
            style={{
              position: "absolute",
              bottom: "4px",
              right: "25px",
              fontSize: "10px",
              color: "green",
            }}
            onClick={() =>
              window.open(
                `/carrier/${selectedCarrierInfo.replace(/\//g, "_")}`,
                "_blank",
              )
            }
          >
            <Button
              variant="link"
              className="p-0 m-0 mb-1"
              disabled={isLoading}
            >
              {selectedCarrierInfo}
            </Button>
            <Icon
              name={"open"}
              overrides={{
                disabled: isLoading,
                tooltip: "",
                size: "0.9rem",
                style: { marginLeft: "5px" },
              }}
              id="open-icon"
            />
          </span>
        </OverlayTrigger>
      </Card>
    </Col>
  );
};
export default CarrierContactCard;
